<template>
  <div class="main" v-bind:class="{ setMarker: setState }">

    <loader v-if="!dataLoaded"></loader>

    <l-map class="mainMap" ref="map" :zoom.sync="zoom" @mousemove="mouseMoveCursor($event)" @moveend="shareMap()" :options="mapOptions" :center="center" :minZoom="minZoom" :maxZoom="maxZoom" @click="mapClick" :crs="crs">

      <l-image-overlay :url="url" :bounds="[[0, 0], [1000, 1000]]"></l-image-overlay>

      <l-area v-for="area in filteredAreas"

        @contextmenu="areaOpen(area)"
        @area-update="onAreaUpdate($event, area)"

        :transformable="areaTransformable(area['.key'])"
        :fill-opacity="areaFillOpacity(area['.key'])"
        :lat-lng="area.latLng"
        :title="area.title"
        :size="area.size"
        :circle="area.circle"
        :class-name="area['.key']"
        :opacity="1"
        :internal="area.internal"
        v-bind:key="area['.key']"
      >
      </l-area>
      <v-marker-cluster ref="clusterRef">
        <l-marker v-for="post in filteredPosts"

          v-if="post['board'] == board"

          @dragend="markerDragEnd($event, post)"
          @click="markerOpen(post)"

          :visible="markerVisible(post)"
          :draggable="markerDraggable(post['.key'])"
          :options="markerOptions"
          :title="post.title"
          :icon="markerIcon(post)"
          :lat-lng="post.position"
          v-bind:key="post.key"
        >
          <l-tooltip v-if="dataLoaded" :class-name="toolTipClassName(post)" :content="post.title" :options="toolTipOptions(post)" />
        </l-marker>
      </v-marker-cluster>

      <l-marker v-if="boardData.sync && !share && boardData.cursor"
        :visible="true"
        :draggable="false"
        :options="{ riseOnHover: true, className: 'presenter' }"
        :title="boardData.user"
        :icon="cursorIcon"
        :lat-lng="boardData.cursor"
      >
        <l-tooltip v-if="dataLoaded" :content="boardData.user" :options="cursorOptions" />
      </l-marker>

      <l-mini-map v-if="dataLoaded" :posts="filteredPosts" :areas="filteredAreas"></l-mini-map>
      <add-to-map v-if="!markerSelected && !setNewData && !historyDate && !createNewModal" @createNew="createNew($event)"></add-to-map>
      <map-place-hint v-if="setNewData"></map-place-hint>
      <map-history-date-hint v-if="historyDate" :date="historyDate"></map-history-date-hint>
      <map-sync v-if="!markerSelected && boardData && !createNewModal && !setNewData && !historyDate" :boardData="boardData" :session="session" @toggleSync="toggleShare()"></map-sync>

    </l-map>

    <div class="sidebar max" v-if="dataLoaded" v-bind:class="{ sidebarPost: markerSelected, sidebarMin: sidebar == 'min', sidebarMax: sidebar == 'max', sidebarFullscreen: fullscreen }">

      <div class="sidebarInner">

        <div v-if="markerSelected == null && areaSelected == null">
          <!-- Normale Sidebar, ohne aktiven Marker -->
          <sidebar-new-posts v-if="!historyMode" :posts="posts" @open="markerOpen($event, true)"></sidebar-new-posts>
          <history-list v-if="dataLoaded && historyMode" :posts="mergedData" @setHistory="setHistoryDate($event)"></history-list>
          <!-- <h2>Projekte</h2> -->
          <!-- <p>Noch keine Projekte angelegt.</p><br /> -->
          <!-- {{ zoom }}<br /> -->
          <!-- <h1>{{ center }}</h1> -->
          <!-- <h1>{{ msg }}</h1> -->
          <!-- <br /> -->
          <!-- {{this.$store.state.safelyStoredNumber}} -->
          <!-- {{currentUser.email}} -->
          <!-- <div v-if="this.$parent.isAuthenticated">Test</div> -->
          <!-- {{this.$parent.auth.user.email}} -->
        </div>

        <div class="markerSlot" v-if="markerSelected != null">
          <edit-marker :marker="markerSelected" @edit-marker-close="editMarkerClose()" @fullscreen="fullscreenToggle()" @jump="jumpTo([$event.latLng.lat, $event.latLng.lng], $event.zoom)" @delete-marker="deleteMarker($event)" :setJump="jump" @update-marker="updateMarker($event)"></edit-marker>
        </div>
        <div v-if="areaSelected != null">
          <edit-area :area="areaSelected" @edit-area-close="editAreaClose()" @delete-area="deleteArea($event)" @update-area="updateArea($event)"></edit-area>
        </div>

      </div>

      <div class="sidebarToggle" v-if="!createNewModal && !setNewData">
        <button @click="setSidebar('bigger')" v-if="sidebar != 'default'" class="btn--subtile sidebar-bigger-button">
          <svgicon v-if="sidebar != 'min'" icon="arrow-circle-left" width="32" height="32" color="#000000"></svgicon>
          <svgicon v-if="sidebar == 'min'" icon="more" width="32" height="32" color="#000000"></svgicon>
           <span v-if="sidebar != 'min'">vergrößern</span>
        </button>
        <button @click="setSidebar('smaller')" v-if="sidebarSetting == 'max' || (sidebarSetting == 'default' && (!areaSelected && !markerSelected))" class="btn--subtile sidebar-smaller-button"><svgicon icon="arrow-circle-right" width="32" height="32" color="#000000"></svgicon> <span v-if="sidebar == 'max'">verkleinern</span></button>
        <div class="clear"></div>
      </div>

    </div>

    <map-create-new v-if="createNewModal" :icons="icons" @setNew="setNew($event)" @abortCreateNew="abortCreateNew()" :type="createNewModal"></map-create-new>

    <map-filter-box v-if="!markerSelected && dataLoaded && !createNewModal && !setNewData" @toggleHistory="toogleHistoryMode()" @searchComplete="searchComplete($event)" :items="filteredPosts" :type="filterType" :project="filterProject" :priority="filterPriority" :tag="filterTag"  :history="historyMode" @setFilter="setFilter($event)"></map-filter-box>

  </div>
</template>

<script>
import firebase from 'firebase/app'
import SimpleUpload from '@/components/SimpleUpload'
import L from 'leaflet' // braucht man das hier für vue2-leaflet?
import { LMap, LPopup, LMarker, LImageOverlay } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
// import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import LArea from '@/components/LArea' // eslint-disable-line
import LTooltip from '@/components/LTooltip' // eslint-disable-line
import EditMarker from '@/components/EditMarker' // eslint-disable-line
import EditArea from '@/components/EditArea' // eslint-disable-line
import LMiniMap from '@/components/LMiniMap' // eslint-disable-line
import SidebarNewPosts from '@/components/SidebarNewPosts' // eslint-disable-line
import AddToMap from '@/components/AddToMap' // eslint-disable-line
import MapSync from '@/components/MapSync' // eslint-disable-line
import MapCreateNew from '@/components/MapCreateNew' // eslint-disable-line
import MapPlaceHint from '@/components/MapPlaceHint' // eslint-disable-line
import MapHistoryDateHint from '@/components/MapHistoryDateHint' // eslint-disable-line
import MapFilterBox from '@/components/MapFilterBox' // eslint-disable-line
import HistoryList from '@/components/HistoryList' // eslint-disable-line
import Loader from '@/components/Loader' // eslint-disable-line
import moment from 'moment'
import cuid from 'cuid'
import _ from 'lodash'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster' // eslint-disable-line

var db = firebase.database()
var isiPad = navigator.userAgent.match(/iPad/i) != null

var areasRef = db.ref('areas')
var postsRef = db.ref('posts')
var boardsRef = db.ref('boards')
var iconsRef = db.ref('icons')
var projectsRef = db.ref('projects')

var uuid = cuid()

export default {
  name: 'Map',
  components: {
    LMap,
    LImageOverlay,
    LMarker,
    LPopup,
    LTooltip,
    LArea,
    LMiniMap,
    SimpleUpload,
    EditMarker,
    SidebarNewPosts,
    AddToMap,
    MapSync,
    EditArea,
    MapPlaceHint,
    MapHistoryDateHint,
    MapFilterBox,
    MapCreateNew,
    HistoryList,
    Loader,
    'v-marker-cluster': Vue2LeafletMarkerCluster
  },
  data () {
    return {
      routerPost: false,
      board: 'development',
      msg: 'Das ist die Default Nachricht!',
      // center: L.latLng(49.1593467, 10.5537924),
      center: L.latLng(500, 500),
      share: false,
      url: require('@/assets/mapBg.svg'),
      minZoom: -100,
      maxZoom: 10,
      miniMapZoomLevel: 3,
      dataLoaded: false,
      zoom: 0,
      attribution: '',
      crs: L.CRS.Simple,
      setState: false,
      activeMarker: null,
      markerDrag: false,
      markerTitleFilter: null,
      markerSelected: null,
      jump: false,
      areaSelected: null,
      currentUser: firebase.auth().currentUser,
      session: uuid,
      createNewModal: false,
      setNewData: false,
      sidebarSetting: 'min',
      historyMode: false,
      historyDate: false,
      fullscreen: false,
      sidebarSettingBefore: null,
      filterPriority: false,
      filterProject: false,
      filterTag: false,
      filterType: false,
      markerOptions: {
        riseOnHover: true,
        draggable: true
      },
      mapOptions: {
        zoomControl: false
      },
      popupOptions: {
        offset: new L.Point(0, 0)
      },
      cursorIcon: new L.Icon({
        iconUrl: require('@/assets/icons/cursor.png'),
        iconSize: [48, 48],
        className: 'presenterIcon'
      }),
      cursorOptions: {
        permanent: true,
        direction: 'right',
        interactive: true,
        className: 'presenterCursor'
      }
    }
  },
  methods: {
    shareMap: function () {
      if (!this.share || !this.board) return
      if (this.session !== this.boardData.session) return
      if (this.boardData.sync !== true) {
        boardsRef.child(this.board).child('sync').set(true)
      }
      if (this.boardData.zoom !== this.zoom) {
        boardsRef.child(this.board).child('zoom').set(this.zoom)
      }
      if (this.boardData.position !== this.center) {
        boardsRef.child(this.board).child('position').set(this.center)
      }
    },
    toggleShare: function () {
      if (this.share) {
        this.share = false
        boardsRef.child(this.board).child('sync').set(false)
        boardsRef.child(this.board).child('user').set('none')
        boardsRef.child(this.board).child('session').set('null')
        boardsRef.child(this.board).child('cursor').set(false)
      } else {
        this.share = true
        boardsRef.child(this.board).child('cursor').set(false)
        boardsRef.child(this.board).child('sync').set(true)
        boardsRef.child(this.board).child('user').set(this.currentUser.email)
        boardsRef.child(this.board).child('session').set(this.session)
        boardsRef.child(this.board).child('zoom').set(this.zoom)
        boardsRef.child(this.board).child('position').set(this.center)
      }
    },
    createNew: function (type) {
      this.createNewModal = type
    },
    setNew: function (data) {
      this.createNewModal = false
      this.setNewData = data
    },
    abortCreateNew: function () {
      this.createNewModal = false
    },
    markerDraggable: function (key) {
      if (this.markerSelected != null) {
        if (key === this.markerSelected['.key']) {
          return true
        }
      }
      return false
    },
    areaTransformable: function (key) {
      if (this.areaSelected != null) {
        if (key === this.areaSelected['.key']) {
          return true
        }
      }
      return false
    },
    areaFillOpacity: function (key) {
      if (this.areaSelected == null) {
        return 0
      } else {
        if (key === this.areaSelected['.key']) {
          return 0.2
        } else {
          return 0
        }
      }
    },
    editMarkerClose: function () {
      this.fullscreen = false
      if (this.sidebarSettingBefore) {
        this.sidebarSetting = this.sidebarSettingBefore
      }
      this.markerSelected = null
    },
    editAreaClose: function () {
      this.fullscreen = false
      if (this.sidebarSettingBefore) {
        this.sidebarSetting = this.sidebarSettingBefore
      }
      this.areaSelected = null
    },
    updateMarker: function (post) {
      postsRef.child(post['.key']).child('title').set(post.title)
      postsRef.child(post['.key']).child('icon').set(post.icon)
      postsRef.child(post['.key']).child('priority').set(post.priority)
      if (post.link) {
        postsRef.child(post['.key']).child('link').set(post.link)
      }
      postsRef.child(post['.key']).child('modified').set(moment().format())
    },
    updateArea: function (area) {
      areasRef.child(area['.key']).child('title').set(area.title)
      areasRef.child(area['.key']).child('internal').set(area.internal)
    },
    deleteMarker: function (post) {
      postsRef.child(post['.key']).remove()
    },
    deleteArea: function (area) {
      areasRef.child(area['.key']).remove()
    },
    mouseMoveCursor: _.throttle(function (event) {
      if (isiPad) return
      if (!this.share || !this.board) return
      boardsRef.child(this.board).child('cursor').set(event.latlng)
    }, 250),
    markerIcon: function (post) {
      var icon = post.icon
      var active = false
      if (this.markerSelected) {
        if (post['.key'] === this.markerSelected['.key']) {
          active = true
        }
      }
      // if (!this.filteredPosts.includes(post)) {
      //   return L.icon({
      //     iconUrl: require('@/assets/icons/' + icon + '_filtered.png'),
      //     iconSize: [16, 16]
      //   })
      // }
      if (active) {
        return L.icon({
          iconUrl: require('@/assets/icons/move.png'),
          iconSize: [18, 18]
        })
      } else {
        if (post.priority === '2') {
          return L.icon({
            iconUrl: require('@/assets/icons/' + icon + '_2.png'),
            iconSize: [18, 18]
          })
        }
        if (post.priority === '1') {
          return L.icon({
            iconUrl: require('@/assets/icons/' + icon + '_1.png'),
            iconSize: [18, 18]
          })
        }
        return L.icon({
          iconUrl: require('@/assets/icons/' + icon + '.png'),
          iconSize: [18, 18]
        })
      }
    },
    markerOpen: function (post, jumper) {
      this.sidebarSettingBefore = this.sidebarSetting
      if (this.markerSelected !== null) {
        if (this.markerSelected['.key'] === post['.key']) {
          // this.editMarkerClose()
          return
        }
        this.editMarkerClose()
      }
      if (this.areaSelected !== null) { this.editAreaClose() }
      if (jumper) {
        this.jump = true
      }
      this.markerSelected = null
      this.$nextTick(() => {
        this.markerSelected = post
      })
    },
    areaOpen: function (area) {
      this.sidebarSettingBefore = this.sidebarSetting
      if (this.markerSelected !== null) { this.editMarkerClose() }
      if (this.areaSelected !== null) { this.editAreaClose() }
      this.areaSelected = area
    },
    markerVisible: function (post) {
      if (!this.markerTitleFilter) { return true }
      if (!post.title) { return false }
      let title = post.title
      if (title.includes(this.markerTitleFilter)) { return true }
      return false
    },
    setFilter: function (event) {
      this.filterProject = event.project
      this.filterPriority = event.priority
      this.filterTag = event.tag
      this.filterType = event.type
    },
    mapClick: function (event) {
      if (this.setNewData) {
        if (this.setNewData.type === 'post') {
          postsRef.push({
            position: event.latlng,
            user: this.$parent.auth.user.uid,
            created: moment().format(),
            title: this.setNewData.title,
            icon: this.setNewData.icon,
            board: this.board,
            priority: this.setNewData.priority
          })
          this.setNewData = false
        }
        if (this.setNewData.type === 'link') {
          postsRef.push({
            position: event.latlng,
            user: this.$parent.auth.user.uid,
            created: moment().format(),
            title: this.setNewData.title,
            link: this.setNewData.link,
            icon: this.setNewData.icon,
            board: this.board,
            priority: this.setNewData.priority
          })
          this.setNewData = false
        }
        if (this.setNewData.type === 'area') {
          let newSize = (this.$refs.map.mapObject.getBounds()._northEast.lat - this.$refs.map.mapObject.getBounds()._southWest.lat) * 0.4
          let size = {
            width: newSize,
            height: newSize
          }
          let min = Math.ceil(0)
          let max = Math.floor(9)
          let circle = Math.floor(Math.random() * (max - min + 1)) + min
          areasRef.push({
            latLng: event.latlng,
            user: this.$parent.auth.user.uid,
            size: size,
            circle: circle,
            internal: false,
            created: moment().format(),
            title: this.setNewData.title,
            board: this.board
          })
          this.setNewData = false
        }
      }
      this.editMarkerClose()
      this.editAreaClose()
    },
    markerDragEnd: function (event, post) {
      postsRef.child(post['.key']).child('position').set(event.target._latlng)
      this.markerSelected = post
    },
    markerClick: function (event, post) {
      if (post.link) {
        window.open(post.link, '_blank')
      }
    },
    onAreaUpdate (event, area) {
      areasRef.child(area['.key']).child('latLng').set(event.latLng)
      areasRef.child(area['.key']).child('size').set(event.size)
    },
    toolTipOptions (post) {
      var add = ''
      if (this.markerSelected) {
        if (post['.key'] === this.markerSelected['.key']) {
          add = 'tooltip--selected'
        }
      }

      // console.log(post)

      if (post.priority) {
        if (post.priority === '2') {
          add = add + ' tooltip--prio2'
        }
        if (post.priority === '1') {
          add = add + ' tooltip--prio1'
        }
      }

      // if (!this.filteredPosts.includes(post)) {
      //   add = add + ' tooltip--filtered'
      // }

      if (post.link || post.content) {
        if (post.link) {
          return {
            permanent: true,
            direction: 'right',
            interactive: true,
            className: 'tooltip--clickable tooltip--link ' + add
          }
        } else {
          return {
            permanent: true,
            direction: 'right',
            interactive: true,
            className: 'tooltip--clickable ' + add
          }
        }
      } else {
        return {
          permanent: true,
          direction: 'right',
          interactive: true,
          className: add
        }
      }
    },
    toolTipClassName (post) {
      var add = ''
      // if (!this.filteredPosts.includes(post)) {
      //   add = add + ' tooltip--filtered'
      // }
      if (this.markerSelected) {
        if (post['.key'] === this.markerSelected['.key']) {
          add = add + ' tooltip--selected'
        }
      }
      if (post.priority === '2') {
        add = add + ' tooltip--prio2'
      }
      if (post.priority === '1') {
        add = add + ' tooltip--prio1'
      }
      return add
    },
    setSidebar (value) {
      // if (setSidebar)
      if (value === 'bigger') {
        if (this.sidebarSetting === 'default') {
          this.sidebarSetting = 'max'
        }
        if (this.sidebarSetting === 'min') {
          if (this.sidebar === 'default') {
            this.sidebarSetting = 'max'
          } else {
            this.sidebarSetting = 'default'
          }
        }
      }
      if (value === 'smaller') {
        if (this.sidebarSetting === 'max') {
          this.sidebarSetting = 'default'
        } else {
          if (this.sidebarSetting === 'default') {
            this.sidebarSetting = 'min'
          }
        }
      }
    },
    jumpTo (latLng, zoom) {
      // [500, 500]
      this.jump = false
      this.$refs.map.mapObject.invalidateSize()
      if (latLng && zoom) {
        this.$refs.map.mapObject.setView(latLng, zoom)
      } else {
        this.$refs.map.mapObject.setView(latLng, 2)
      }
    },
    setHistoryDate (data) {
      let date = data.created
      this.historyDate = date
    },
    toogleHistoryMode () {
      if (this.historyMode) {
        if (this.sidebarSettingBefore) {
          this.sidebarSetting = this.sidebarSettingBefore
        }
        this.historyMode = false
        this.historyDate = false
      } else {
        this.sidebarSettingBefore = this.sidebarSetting
        this.editMarkerClose()
        this.editAreaClose()
        this.historyMode = true
      }
    },
    fullscreenToggle () {
      if (this.fullscreen) {
        this.fullscreen = false
      } else {
        this.fullscreen = true
      }
    },
    searchComplete (data) {
      if (_.find(this.areas, { '.key': data })) {
        // Area
        let target = _.find(this.areas, { '.key': data }).latLng
        this.jumpTo([target.lat, target.lng], 2)
      } else {
        // Post
        this.markerOpen(_.find(this.posts, { '.key': data }), true)
      }
    }
  },
  computed: {
    sidebar: function () {
      if ((this.markerSelected || this.areaSelected || this.historyMode) && this.sidebarSetting === 'min') return 'default'
      return this.sidebarSetting
    },
    mergedData: function () {
      var data = _.concat(this.posts, this.areas)
      return _.orderBy(data, ['created'], ['desc'])
    },
    mergedFilteredData: function () {
      var data = _.concat(this.filteredPosts, this.filteredAreas)
      return _.orderBy(data, ['created'], ['desc'])
    },
    filteredPosts: function () {
      let dataPosts = this.posts
      var self = this // eslint-disable-line
      if (this.historyDate) {
        let date = this.historyDate
        dataPosts = _.filter(dataPosts, function (v) { return v.created <= date })
      }
      if (this.filterPriority) {
        let prio = this.filterPriority // eslint-disable-line
        dataPosts = _.filter(dataPosts, function (v) { return v.priority === prio })
      }
      if (this.filterProject) {
        let project = this.filterProject // eslint-disable-line
        let projectItems = _.find(this.projects, { '.key': project }).items
        dataPosts = _.filter(dataPosts, function (v) { return projectItems[v['.key']] })
      }
      if (this.filterTag) {
        let tag = this.filterTag // eslint-disable-line
        dataPosts = _.filter(dataPosts, function (v) {
          if (v.tags) {
            return v.tags[tag]
          }
        })
      }
      if (this.filterType) {
        let type = this.filterType // eslint-disable-line
        dataPosts = _.filter(dataPosts, function (v) { return v.icon === type })
      }
      return dataPosts
    },
    filteredAreas: function () {
      let dataAreas = this.areas
      if (this.historyDate) {
        let date = this.historyDate
        dataAreas = _.filter(dataAreas, function (v) { return v.created <= date })
      }
      return dataAreas
    }
  },
  mounted () {
    this.$refs.map.mapObject.setView([500, 500], 1)
    this.routerPost = this.$route.params.post
    // var bounds = new L.latLngBounds()
    // this.mapObject.fitBounds(bounds)//works!
    // this.$refs.map.mapObject.fitBounds(bounds)
    postsRef.once('value', snapshot => {
      this.dataLoaded = true
      if (this.routerPost !== undefined) {
        this.markerOpen(_.find(this.posts, { '.key': this.routerPost }), true)
        this.$refs.map.mapObject.setView([this.$route.params.position.lat, this.$route.params.position.lng], 2.3)
      }
      if (this.$route.params.project !== undefined) {
        this.setFilter({ project: this.$route.params.project })
        // this.filterProject = this.$route.params.project
      }
      if (this.$route.params.tag !== undefined) {
        this.setFilter({ tag: this.$route.params.tag })
        // this.filterProject = this.$route.params.project
      }
      let checkBounds = []
      this.filteredPosts.forEach(post => {
        checkBounds.push([post.position.lat, post.position.lng])
      })
      this.filteredAreas.forEach(post => {
        checkBounds.push([post.latLng.lat - post.size.height / 2, post.latLng.lng + post.size.width / 2])
        checkBounds.push([post.latLng.lat + post.size.height / 2, post.latLng.lng - post.size.width / 2])
      })
      this.$refs.map.mapObject.fitBounds(checkBounds)
    })
  },
  firebase () {
    return {
      areas: areasRef,
      posts: postsRef,
      boards: boardsRef,
      icons: iconsRef,
      boardData: {
        source: db.ref('boards/' + this.board),
        asObject: true
      },
      projects: projectsRef
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.mainMap {
  height: 100vh;
  // width: 70vw;
  -webkit-user-select: none;  /* Chrome all / Safari all */
  -moz-user-select: none;     /* Firefox all */
  -ms-user-select: none;      /* IE 10+ */
  user-select: none;
  position: relative;
  z-index: 1;
}
.sidebar {
  height: 100vh;
  width: 60vw;
  text-align: left;
  background: #fff;
  position: relative;
  z-index: 2;
  box-shadow: 0 2px 24px 0 rgba(38,50,56,0.1);
  box-sizing: border-box;
  padding: relative;

  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) {
    width: 100%;
  }

  &.sidebarFullscreen {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    z-index: 200;
    &.sidebarPost {
      .markerSlot {
        width: 800px;
        max-width: 100%;
        margin: 50px auto;
      }
    }
  }

  transition: width 0.14s ease-in-out, transform 0.14s ease-in-out;

  .sidebarInner {
    transition: all 0.14s ease;
  }

  &.sidebarMax {
    width: 120%;
  }

  &.sidebarMin {
    // width: 350px;
    width: 0px;
    // transform: translateX(20vw);
    .sidebarToggle {
      margin-left: -50px;
      width: 50px;
      z-index: 9999;
      // background: #efefef;
      background: rgba($color-action,0.9);
      // background: rgba(255,255,255,0.9);
      button {
        // color: $color-action;
        color: #fff;
      }
      bottom: 50%;
      margin-bottom: -23px;
      &:before {
        display: none;
      }
    }
  }
  &.sidebarPost {
    .sidebarInner {
      bottom: 0;
    }
  }

  .sidebarInner {
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 46px;
    padding: 0px 30px;
  }
}

.sidebarToggle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  background: rgba($color-text, 0.05);
  button {
    margin-bottom: 0;
    color: $color-action;

    &:hover {
      color: darken($color-action,7.5%);
    }
  }
  &:before {
    position: absolute;
    top: -30px;
    left: 0;
    right: 0;
    content: " ";
    height: 30px;
    background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  }

  .sidebar-bigger-button {
    padding-left: 15px !important;
    float: left;
  }

  .sidebar-smaller-button {
    float: right;
    padding-right: 15px !important;
  }
}

.main {
  display: flex;
  width: calc(100% - 100px);
  position: absolute;
  left: 100px;
  top: 0;
  bottom: 0;
  right: 0;
}

.mainMap.leaflet-container {
  background-color: $background-color;
  background-color: darken($background-color,1%);
  font-family: 'Dosis', sans-serif;
}

  .mainMap .leaflet-tooltip {
    // background-color:  transparent;
    // padding-left: 10px;
    font-family: 'Dosis', sans-serif;
    border:none;
    color: $color-text;
    box-shadow:none;
    font-size: 15px;
    letter-spacing: 0.25px;
    margin-left: 12px;
    font-weight: 600;
    color: $color-action;
    border-radius: 2px;
    padding-left: 10px;
    padding-right: 10px;
    background-color: rgba(255,255,255,0.5);
    opacity: 1 !important;
  }

  .mainMap .leaflet-marker-draggable {
    cursor: move;
  }

  .mainMap .leaflet-marker-pane svg {
    pointer-events: none;
  }

  .mainMap .leaflet-tooltip-right:before {
    display:none;
    // border-right-color: rgba(255,255,255,0.5);
  }

  .mainMap .leaflet-marker-icon text {
    text-transform: uppercase;
    letter-spacing: 1px;
    opacity: 0.75;
  }

  .tooltip--link {
    &:after {
      content: " " url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIpJREFUeNqEkIEJwCAMBGPpEs7hHK6hY+gauoZr6Bo6RtqEWkxb6EMQnuM/USEirIoxSmOKwDkhBEwp4VPkb4801Xun9xW4e+9FldYarLUvkBPPOp4JGWOgtSaSt6VWQKUU9nPOEiSIgAmNMdadFTjn7utqrXwh6fLvH9nXhamW5ksMnpfDnw4BBgBfunO056MmqAAAAABJRU5ErkJggg==);
      margin-top: -2px;
      display: inline-block;
      margin-left: 2px;
    }
  }

  .mainMap .presenterCursor {
    background: rgba($color-error,0.8);
    color: #fff;
    margin-top: 6px;
    margin-left: 25px;
  }

  .mainMap .tooltip--selected {
    background: $color-action;
    color: #fff;
    margin-left: 12px;
    // &::before {
    //   border-right-color: $color-action;
    // }
  }

  .mainMap img.leaflet-interactive.leaflet-marker-icon {
    opacity: 0.5 !important;
    &:hover {
      opacity: 1 !important;
    }
  }

  .mainMap img.leaflet-interactive.leaflet-marker-icon.presenterIcon {
    opacity: 1 !important;
  }

  .mainMap .leaflet-control-minimap {
    box-shadow: none !important;
    border: 1px solid rgba($color-action,0.25);
  }

  .mainMap .tooltip--prio1 {
    color: $color-error;
    &.tooltip--selected {
      color: #fff;
      background: $color-error;
    }
  }

  .mainMap .tooltip--prio2 {
    color: $color-warn;
    &.tooltip--selected {
      color: #fff;
      background: $color-warn;
    }
  }

  .mainMap .tooltip--filtered {
    opacity: 0.1 !important;
    background: transparent !important;
    font-weight: 400;
    color: $color-action !important;
  }

  .leaflet-right .leaflet-control {
    margin-right: 15px;
    margin-bottom: 15px;
  }

  .leaflet-left .leaflet-control {
    margin-left: 20px;
  }

  .leaflet-top .leaflet-control {
    margin-top: 20px;
  }

  .leaflet-control-minimap {
        // box-shadow: 0 1px 5px rgba(0,0,0,.2);
      .leaflet-interactive[stroke='#333'] {
        fill: $color-highlight !important;
      }
  }

</style>



// WEBPACK FOOTER //
// src/components/Map.vue